export function validateEmail(value) {
  return /^[A-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? null : true;
}

export function validateTeamSelection(value) {
  return value === '-- Select a Team --';
}

export function isRequiredError(inputName) {
  return `${inputName} is required`;
}

export function isInvalidError(inputName) {
  return `Please enter a valid ${inputName}`;
}

export function runInputValidation(input) {
  const {
    value,
    required,
    validator,
    name,
  } = input;

  let error = null;

  if (!value && required) {
    error = isRequiredError(name);
  } else if (validator && validator(value)) {
    error = isInvalidError(name);
  }

  return error;
}

export function runFormValidation(form) {
  const errors = {};

  Object.keys(form).forEach((key) => {
    if (runInputValidation(form[key])) {
      errors[form[key].name] = runInputValidation(form[key]);
    }
  });

  return errors;
}
